export default __webpack_public_path__ + "static/media/lasttime_tn.5860c029.jpg";